/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Address from './Address';
import HydroSystemStatus from './HydroSystemStatus';

/**
 * The FireControllerStatusReport model module.
 * @module model/FireControllerStatusReport
 * @version 1.1.0
 */
class FireControllerStatusReport {
    /**
     * Constructs a new <code>FireControllerStatusReport</code>.
     * Fire controller device identity and location, with optional status when online
     * @alias module:model/FireControllerStatusReport
     * @param fireControllerId {String} Unique identifier of the fire controller device
     */
    constructor(fireControllerId) { 
        
        FireControllerStatusReport.initialize(this, fireControllerId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, fireControllerId) { 
        obj['fireControllerId'] = fireControllerId;
    }

    /**
     * Constructs a <code>FireControllerStatusReport</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FireControllerStatusReport} obj Optional instance to populate.
     * @return {module:model/FireControllerStatusReport} The populated <code>FireControllerStatusReport</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FireControllerStatusReport();

            if (data.hasOwnProperty('fireControllerId')) {
                obj['fireControllerId'] = ApiClient.convertToType(data['fireControllerId'], 'String');
            }
            if (data.hasOwnProperty('hydroSystemStatus')) {
                obj['hydroSystemStatus'] = ApiClient.convertToType(data['hydroSystemStatus'], HydroSystemStatus);
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], Address);
            }
            if (data.hasOwnProperty('latitude')) {
                obj['latitude'] = ApiClient.convertToType(data['latitude'], 'Number');
            }
            if (data.hasOwnProperty('longitude')) {
                obj['longitude'] = ApiClient.convertToType(data['longitude'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FireControllerStatusReport</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FireControllerStatusReport</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of FireControllerStatusReport.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['fireControllerId'] && !(typeof data['fireControllerId'] === 'string' || data['fireControllerId'] instanceof String)) {
            throw new Error("Expected the field `fireControllerId` to be a primitive type in the JSON string but got " + data['fireControllerId']);
        }
        // validate the optional field `hydroSystemStatus`
        if (data['hydroSystemStatus']) { // data not null
          HydroSystemStatus.validateJSON(data['hydroSystemStatus']);
        }
        // validate the optional field `address`
        if (data['address']) { // data not null
          Address.validateJSON(data['address']);
        }

        return true;
    }


}

FireControllerStatusReport.RequiredProperties = ["fireControllerId"];

/**
 * Unique identifier of the fire controller device
 * @member {String} fireControllerId
 */
FireControllerStatusReport.prototype['fireControllerId'] = undefined;

/**
 * Current hydro system status; null when the device is offline
 * @member {module:model/HydroSystemStatus} hydroSystemStatus
 */
FireControllerStatusReport.prototype['hydroSystemStatus'] = undefined;

/**
 * Physical address of the fire controller device
 * @member {module:model/Address} address
 */
FireControllerStatusReport.prototype['address'] = undefined;

/**
 * Latitude coordinate of the fire controller device
 * @member {Number} latitude
 */
FireControllerStatusReport.prototype['latitude'] = undefined;

/**
 * Longitude coordinate of the fire controller device
 * @member {Number} longitude
 */
FireControllerStatusReport.prototype['longitude'] = undefined;






export default FireControllerStatusReport;

